export default "__VITE_ASSET__BjCVcBSD__"